import { CoreContext as ToolbarContext } from "@piqnt/runtime-core/context";

export const toolsList = [
  {
    name: "inspect",
    activate: (context: ToolbarContext) => {
      context.activeTool.value = { name: "inspect" };
    },
  },
  {
    name: "multiselect",
    activate: (context: ToolbarContext) => {
      context.activeTool.value = { name: "multiselect" };
    },
  },
  {
    name: "edit-world",
    activate: (context: ToolbarContext) => {
      context.activeTool.value = { name: "edit-world" };
    },
  },
  {
    name: "pull",
    activate: (context: ToolbarContext) => {
      context.activity.value = "mode:play";
      context.paused.value = false;
      context.editable.value = false;
      context.activeTool.value = { name: "interact-pull" };
    },
  },
  {
    name: "impulse",
    activate: (context: ToolbarContext) => {
      context.activity.value = "mode:play";
      context.paused.value = false;
      context.editable.value = false;

      context.activeTool.value = { name: "interact-impulse" };
    },
  },
];
